import { type JSX } from 'react/jsx-runtime';

export const AssetsIcon = (): JSX.Element => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_1788_42960)">
			<g clipPath="url(#clip1_1788_42960)">
				<path
					d="M2 7C2 4.23858 4.23858 2 7 2H17C19.7614 2 22 4.23858 22 7V17C22 19.7614 19.7614 22 17 22H7C4.23858 22 2 19.7614 2 17V7Z"
					fill="#DDDEE1"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M9.29102 11.6408C10.5161 11.4881 11.4871 10.5171 11.6399 9.29199H13.3535V7.93783H11.4639C11.0622 6.94528 10.0891 6.24512 8.95247 6.24512C7.4567 6.24512 6.24414 7.45768 6.24414 8.95345C6.24414 10.0901 6.9443 11.0631 7.93685 11.4649L7.93685 13.3545H9.29102V11.6408ZM8.95247 9.96908C9.51339 9.96908 9.9681 9.51436 9.9681 8.95345C9.9681 8.39254 9.51339 7.93783 8.95247 7.93783C8.39156 7.93783 7.93685 8.39254 7.93685 8.95345C7.93685 9.51436 8.39156 9.96908 8.95247 9.96908Z"
					fill="#1E1F21"
				/>
				<path
					d="M17.416 8.61491C17.416 9.54977 16.6582 10.3076 15.7233 10.3076C14.7885 10.3076 14.0306 9.54977 14.0306 8.61491C14.0306 7.68005 14.7885 6.9222 15.7233 6.9222C16.6582 6.9222 17.416 7.68005 17.416 8.61491Z"
					fill="#1E1F21"
				/>
				<path
					d="M8.61393 17.417C9.54879 17.417 10.3066 16.6591 10.3066 15.7243C10.3066 14.7894 9.54879 14.0316 8.61393 14.0316C7.67908 14.0316 6.92122 14.7894 6.92122 15.7243C6.92122 16.6591 7.67908 17.417 8.61393 17.417Z"
					fill="#1E1F21"
				/>
				<path
					d="M15.7233 17.417C16.6582 17.417 17.416 16.6591 17.416 15.7243C17.416 14.7894 16.6582 14.0316 15.7233 14.0316C14.7885 14.0316 14.0306 14.7894 14.0306 15.7243C14.0306 16.6591 14.7885 17.417 15.7233 17.417Z"
					fill="#1E1F21"
				/>
				<path d="M13.3535 15.0472H10.9837V16.4014H13.3535V15.0472Z" fill="#1E1F21" />
				<path d="M15.0462 10.9847V13.3545H16.4004V10.9847H15.0462Z" fill="#1E1F21" />
			</g>
		</g>
		<defs>
			<clipPath id="clip0_1788_42960">
				<rect width="20" height="20" fill="white" transform="translate(2 2)" />
			</clipPath>
			<clipPath id="clip1_1788_42960">
				<rect width="20" height="20" fill="white" transform="translate(2 2)" />
			</clipPath>
		</defs>
	</svg>
);
